import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharedDataService } from '../../Services/SharedServices/shared-data.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'] // fixed typo: styleUrl -> styleUrls
})
export class HomeComponent {
  Series: any;
  showspinfo = false;
  showcdinfo = false;

  constructor(
    private sharedDataService: SharedDataService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Set info flags based on URL
   // const url = this.router.url.toLowerCase();
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }

    this.sharedDataService.series$.subscribe(series => {
      console.log('Series received in HomeComponent:', series);
      if (series) {
        console.log("MY SERIES IS", series);
        this.Series = series;
      }
    });
  }
}